export const copyToClipboard = async (text: string) => {
  if (!navigator.clipboard) {
    const textElement = document.createElement('textarea');
    textElement.value = text;
    textElement.style.top = '0';
    textElement.style.left = '0';
    textElement.style.position = 'fixed';

    try {
      document.body.appendChild(textElement);
      textElement.focus();
      textElement.select();
      document.execCommand('copy');
    } catch (err) {
      // noop
    } finally {
      document.body.removeChild(textElement);
    }

    return;
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    // noop
  }
};
